
export const DARK_DEFAULT_LINEAR_COLOR = [
  '#1F2225,#36393E',
  '#202B36,#2E4D3C',
  '#1F4259,#4A8C67',
  '#124D40,#80723E',
  '#0E2933,#4B3266',
  '#331130,#4D2116',
  '#36454D,#7A7D80',
  '#3D3421,#8C8446',
]

export const LIGHT_DEFAULT_LINEAR_COLOR = [
  '#E6EAF2,#FFFFFF',
  '#E5FFCC,#F0FFE0',
  '#B6DAF2,#C4FFDE',
  '#E2FFE0,#FFE1D9',
  '#BFD9FF,#E7D1FF',
  '#FFD1BF,#FFE8BD',
  '#CFDEE5,#DFE3E5',
  '#FFFFB2,#FDFFD1',
]

export const DARK_LAYOUT_LINEAR_COLOR = [
  '#1A1C1F,#1A1C1F',
  '#13171B,#1F3429',
  '#18384D,#378056',
  '#0F4035,#806D25',
  '#1B5366,#714B99',
  '#4D1A49,#672514',
  '#3F515A,#7F8285',
  '#4B3D21,#998E38',
]

export const LIGHT_LAYOUT_LINEAR_COLOR = [
  '#E6EAF2,#FFFFFF',
  '#CDE5B5,#DAFFB6',
  '#A3C3D9,#BFFFDB',
  '#D3EED1,#F7DCD4',
  '#A1BCE5,#CEB8E5',
  '#F7C2AD,#FADBA1',
  '#BECDD4,#DAEAF2',
  '#FFF0A3,#FAFAAF',
]

// 预设房间主题套装
export const THEME_PRESET_CONFIGS = [
  {
    bg_color: '',
    bar_color: '',
    type: 'follow',
    name: '跟随外观设置'
  },
  {
    bg_color: '#1F2225,#36393E',
    bar_color: '#1A1C1F,#1A1C1F',
    type: 'dark',
    name: '深夜之蚀'
  },
  {
    bg_color: '#E6EAF2,#FFFFFF',
    bar_color: '#DCDFE6,#DCDFE6',
    type: 'light',
    name: '极地之白'
  },
  {
    bg_color: '#151915,#294235',
    bar_color: '#2B3E35,#32493B',
    type: 'dark',
    name: '森林幽影'
  },
  {
    bg_color: '#162B39,#365D47',
    bar_color: '#114352,#2F744D',
    type: 'dark',
    name: '深渊幽碧'
  },
  {
    bg_color: '#0D2C25,#463D1C',
    bar_color: '#0F4035,#58521E',
    type: 'dark',
    name: '暮光迷雾'
  },
  {
    bg_color: '#020B25,#19473F',
    bar_color: '#08225C,#0D5044',
    type: 'dark',
    name: '苍穹夜蓝'
  },
  {
    bg_color: '#042430,#4B3266',
    bar_color: '#074053,#62378F',
    type: 'dark',
    name: '暮紫沉香'
  },
  {
    bg_color: '#2E0B20,#504020',
    bar_color: '#55132F,#5E4219',
    type: 'dark',
    name: '古铜余烬'
  },
  {
    bg_color: '#2B373D,#666A6E',
    bar_color: '#354953,#6E767E',
    type: 'dark',
    name: '月岩灰'
  },
  {
    bg_color: '#382F1E,#847D47',
    bar_color: '#4B3D21,#998E38',
    type: 'dark',
    name: '复古金'
  },
  {
    bg_color: '#DAF3D1,#F0FFE0',
    bar_color: '#C6DDAE,#DAFFB6',
    type: 'light',
    name: '草语轻韵'
  },
  {
    bg_color: '#C6DFF6,#DBF5DC',
    bar_color: '#9DB8E1,#E3FBCC',
    type: 'light',
    name: '冰河光泽'
  },
  {
    bg_color: '#E7FFE5,#FFE7E0',
    bar_color: '#DEEBB3,#FFD5C9',
    type: 'light',
    name: '晨曦微光'
  },
  {
    bg_color: '#DEF7FD,#DAF4E5',
    bar_color: '#B5DAD1,#9BDDB7',
    type: 'light',
    name: '青空之息'
  },
  {
    bg_color: '#D4E5FF,#F1E4FF',
    bar_color: '#A1BCE5,#CEB8E5',
    type: 'light',
    name: '淡紫浅梦'
  },
  {
    bg_color: '#FFDCCF,#FFF9D9',
    bar_color: '#F7C2AD,#FFE299',
    type: 'light',
    name: '沙滩晨曦'
  },
  {
    bg_color: '#DBEAF1,#F5FCFF',
    bar_color: '#B0BBC0,#F5FCFF',
    type: 'light',
    name: '雾都朦胧'
  },
  {
    bg_color: '#F9F9DA,#F9FAE2',
    bar_color: '#E2D69A,#FFFFD2',
    type: 'light',
    name: '绵润奶油'
  },
]

// 页面主题
export const PAGE_THEME_CONFIGS = [
  {
    type: 'follow',
    name: '跟随系统',
    data: {
      "bg_pic": "",
      "bg_color": "",
      "bar_color": "",
      "blur_rate": 0,
      "transparency": 0,
      "main_color_v2": 0,
      "bar_main_color_v2": 0,
      "bg_pic_main_color": "",
      "show_channel_bar_filter": false,
    }
  },
  {
    bg_color: ['#1F2225', '#36393E'],
    type: 'dark',
    name: '酷黑',
    data: {
      "bg_pic": "",
      "bg_color": "",
      "bar_color": "",
      "blur_rate": 0,
      "transparency": 0,
      "main_color_v2": 1,
      "bar_main_color_v2": 1,
      "bg_pic_main_color": "",
      "show_channel_bar_filter": false,
    }
  },
  {
    bg_color: ['#E6EAF2' ,'#FFFFFF'],
    type: 'light',
    name: '明亮',
    data: {
      "bg_pic": "",
      "bg_color": "",
      "bar_color": "",
      "blur_rate": 0,
      "transparency": 0,
      "main_color_v2": 2,
      "bar_main_color_v2": 2,
      "bg_pic_main_color": "",
      "show_channel_bar_filter": false,
    }
  },
]


export const DEFAULT_CARD_LINEAR_COLOR = [
  '#87A96D,#286E81',
  '#B9BF0B,#24927B',
  '#248CB2,#6840C1',
  '#D15458,#8957D9',
  '#CCAC37,#B02CAE',
  '#CFB54C,#609895',
  '#E0A84C,#B23E65',
  '#E08177,#5DACCF',
]

export enum DEFAULT_ROOM_COLOR_TYPE {
  FOLLOW,
  DARK,
  LIGHT,
}

export enum DEFAULT_COLOR_TYPE {
  DARK,
  LIGHT,
}

// 房间背景图开关相关配置
export const  ROOM_DECORATE_SWITCH = {
  default: 0, // 默认逻辑，根据房间can_change_bg_pic来判断是否能上传
  open_all: 1, // 全部开启，房间都可以上传
  close_all: 2, // 全部关闭，房间都不可以上传
}